import { useInitializeDatadog } from "./useInitializeDatadog";
import { useInitializeSegment } from "./useInitializeSegment";
import { useInitializeMobileAppStateAnalytics } from "@src/mobile/hooks/useInitializeMobileAppStateAnalytics";

export function useInitializeMonitoring() {
  useInitializeDatadog();
  useInitializeSegment();
  useInitializeMobileAppStateAnalytics();
}
